import React from 'react'
import { Box, Typography, Link, Collapse } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import MapImage from './MapImage'

const AttendanceStepper = ({ steps, activeStep, loading, showMap, toggleMap }) => {
  // Debug logging

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <Typography>Loading...</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {steps.map((step, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <RadioButtonCheckedIcon
                sx={{
                  color:
                    index === 0 || index === steps.length - 1
                      ? 'alternate.main'
                      : 'gray-line.main',
                }}
              />
              <Box sx={{ display: 'flex', gap: 1, pl: 1.75 }}>
                <Typography variant="subtitle1">
                  {step.label}
                </Typography>
              </Box>
            </Box>

            {/* View Map Link */}
            {step.hasMap && (
              <Link
                component="button"
                variant="body2"
                onClick={() => toggleMap(index)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  textDecoration: 'none',
                  color: 'primary.main',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {showMap[index] ? <ExpandLess /> : <ExpandMore />}
                {showMap[index] ? 'Hide Map' : 'View Map'}
              </Link>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              ...(index !== steps.length - 1
                ? {
                  borderLeft: '1px solid',
                  borderColor: 'gray-line.main',
                }
                : { borderLeft: '1px solid', borderColor: 'transparent' }),
              ml: 1.5,
              pl: 3,
              pt: 1,
              pb: 2.5,
            }}
          >
            <Typography sx={{ color: 'light-gray-text.main' }}>
              {step.description ? step.description : '[No location recorded]'}
            </Typography>

            {/* Map Display - Hidden by default */}
            {/* <Collapse in={showMap[index]}>
              {step.hasMap && step.coordinates && (
                <Box sx={{ mt: 2 }}>
                  <MapImage
                    latitude={parseFloat(step.coordinates.latitude)}
                    longitude={parseFloat(step.coordinates.longitude)}
                    width={400}
                    height={200}
                    zoom={15}
                  />
                </Box>
              )}
            </Collapse> */}

            {/* Step Note */}
            {step.note && (
              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                Note: {step.note}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default AttendanceStepper
